(() => {
  const root = document.querySelector('[data-lbx-about]');
  if (!root) return;



  const typeword = root.querySelector('[data-lbx-about-typeword]');
  if (typeword) {
    const words = (typeword.getAttribute('data-words') || 'Pioneros|Líderes|Referentes')
      .split('|')
      .map((word) => word.trim())
      .filter(Boolean);

    if (words.length > 1) {
      let wordIndex = 0;
      let charIndex = words[0].length;
      let deleting = false;
      let pauseUntil = 0;

      typeword.textContent = words[0];

      const tickTypeword = (now) => {
        const current = words[wordIndex];

        if (now < pauseUntil) {
          window.setTimeout(() => requestAnimationFrame(tickTypeword), 80);
          return;
        }

        if (!deleting) {
          charIndex += 1;
          typeword.textContent = current.slice(0, charIndex);

          if (charIndex >= current.length) {
            deleting = true;
            pauseUntil = now + 1350;
          }
        } else {
          charIndex -= 1;
          typeword.textContent = current.slice(0, Math.max(0, charIndex));

          if (charIndex <= 0) {
            deleting = false;
            wordIndex = (wordIndex + 1) % words.length;
            pauseUntil = now + 160;
          }
        }

        const delay = deleting ? 44 : 72;
        window.setTimeout(() => requestAnimationFrame(tickTypeword), delay);
      };

      window.setTimeout(() => requestAnimationFrame(tickTypeword), 1150);
    }
  }

    const revealItems = root.querySelectorAll('.lbx-about-reveal');
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
  revealItems.forEach((el) => io.observe(el));

  const heroMedia = root.querySelector('[data-lbx-parallax]');
  if (heroMedia && window.matchMedia('(pointer: fine)').matches) {
    window.addEventListener('mousemove', (event) => {
      const x = (event.clientX / window.innerWidth - 0.5) * 18;
      const y = (event.clientY / window.innerHeight - 0.5) * 14;
      heroMedia.style.setProperty('--ab-parallax-x', `${x}px`);
      heroMedia.style.setProperty('--ab-parallax-y', `${y}px`);
    }, { passive: true });
  }

  const timeline = root.querySelector('[data-lbx-timeline]');
  const progress = root.querySelector('[data-timeline-progress]');
  const updateTimeline = () => {
    if (!timeline || !progress) return;
    const rect = timeline.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    const raw = total <= 0 ? 1 : Math.min(1, Math.max(0, -rect.top / total));
    progress.style.width = `${raw * 100}%`;
  };
  updateTimeline();
  window.addEventListener('scroll', updateTimeline, { passive: true });
  window.addEventListener('resize', updateTimeline);



  // Ticker horizontal real, igual que el marquee de la home.
  // No depende de CSS animations porque algunos themes/ajustes globales pueden bloquearlas.
  const tickerTracks = root.querySelectorAll('.lbx-about-hero__ticker-track');
  tickerTracks.forEach((track) => {
    const ticker = track.closest('.lbx-about-hero__ticker');
    if (!ticker) return;

    const originalHTML = track.innerHTML.trim();
    if (!originalHTML) return;

    // Duplicamos el contenido hasta tener ancho suficiente para un bucle continuo.
    let safety = 0;
    while (track.scrollWidth < ticker.offsetWidth * 2.4 && safety < 8) {
      track.insertAdjacentHTML('beforeend', originalHTML);
      safety += 1;
    }

    track.setAttribute('data-lbx-about-ticker-active', 'true');

    let x = 0;
    let last = performance.now();
    const speed = 64; // px/s. Visualmente parecido al marquee de la home.

    const halfWidth = () => Math.max(1, track.scrollWidth / 2);

    const animateTicker = (now) => {
      const delta = Math.min(64, now - last) / 1000;
      last = now;
      x -= speed * delta;

      const reset = halfWidth();
      if (Math.abs(x) >= reset) x += reset;

      track.style.transform = `translate3d(${x}px, 0, 0)`;
      requestAnimationFrame(animateTicker);
    };

    requestAnimationFrame(animateTicker);
  });


  const tiltCards = root.querySelectorAll('.lbx-tilt');
  if (window.matchMedia('(pointer: fine)').matches) {
    tiltCards.forEach((card) => {
      card.addEventListener('mousemove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--tilt-y', `${x * 4.5}deg`);
        card.style.setProperty('--tilt-x', `${y * -4.5}deg`);
      });
      card.addEventListener('mouseleave', () => {
        card.style.setProperty('--tilt-y', '0deg');
        card.style.setProperty('--tilt-x', '0deg');
      });
    });
  }

  const counters = root.querySelectorAll('[data-lbx-count]');
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const original = el.getAttribute('data-lbx-count') || el.textContent || '';
      const numeric = original.match(/[\d.]+/);
      if (!numeric) {
        counterObserver.unobserve(el);
        return;
      }
      const suffix = original.replace(numeric[0], '');
      const prefix = original.slice(0, original.indexOf(numeric[0]));
      const target = Number(numeric[0].replace(/\./g, ''));
      if (!Number.isFinite(target) || target <= 0 || target > 20000) {
        counterObserver.unobserve(el);
        return;
      }
      const start = performance.now();
      const duration = 5200;
      const format = (value) => {
        const rounded = Math.round(value);
        return `${prefix}${rounded.toLocaleString('es-ES')}${suffix}`;
      };
      const tick = (time) => {
        const progress = Math.min(1, (time - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = format(target * eased);
        if (progress < 1) requestAnimationFrame(tick);
        else el.textContent = original;
      };
      requestAnimationFrame(tick);
      counterObserver.unobserve(el);
    });
  }, { threshold: 0.45 });
  counters.forEach((counter) => counterObserver.observe(counter));
})();
